  (function(){
    "use strict";

    function initializeVs22h(root){
      if(!root||root.dataset.vs22hReady==="true")return;
      root.dataset.vs22hReady="true";
      root.classList.add("vs22h-motion");

    var stage=root.querySelector(".vs22h-stage");
    var backCanvas=root.querySelector(".vs22h-confetti-back");
    var frontCanvas=root.querySelector(".vs22h-confetti-front");
    var promoImage=root.querySelector(".vs22h-promo-layer");
    var reduceMotion=window.matchMedia("(prefers-reduced-motion: reduce)");
    var finePointer=window.matchMedia("(hover: hover) and (pointer: fine)");
    var desktopMedia=window.matchMedia("(min-width: 768px)");
    var saveData=Boolean(navigator.connection&&navigator.connection.saveData);
    var lowPower=Boolean(navigator.hardwareConcurrency&&navigator.hardwareConcurrency<=4);
    var headerSpacer=root.querySelector(".vs22h-desktop-header-spacer");
    var headerResizeObserver;
    var headerResizeFrame=0;
    var primarySlide=root.querySelector('[data-vs22h-slide="primary"]');
    var videoSlide=root.querySelector('[data-vs22h-slide="video"]');
    var video=root.querySelector(".vs22h-video");
    var videoPlayButton=root.querySelector(".vs22h-video-play");
    var slidePrimaryActive=true;
    var carouselInView=true;
    var carouselPrimaryTimer=0;
    var carouselWarmTimer=0;
    var carouselUiTimer=0;
    var primaryStartedAt=0;
    var primaryDuration=13500;
    var fallbackVideoDuration=43.468;
    var slideButtons=Array.prototype.slice.call(root.querySelectorAll("[data-vs22h-target]"));
    var countdown=root.querySelector("[data-vs22h-countdown]");
    var progress=root.querySelector("[data-vs22h-progress]");
    var onPrimarySlideActivated=function(){};
    var videoCodecSupported=Boolean(
      video&&(
        video.canPlayType('video/mp4; codecs="avc1.640028, mp4a.40.2"')
        ||video.canPlayType("video/mp4")
      )
    );
    var carouselAllowed=Boolean(
      primarySlide
      &&videoSlide
      &&video
      &&videoCodecSupported
      &&!reduceMotion.matches
      &&!saveData
    );

    function clearCarouselTimers(){
      if(carouselPrimaryTimer){
        window.clearTimeout(carouselPrimaryTimer);
        carouselPrimaryTimer=0;
      }
      if(carouselWarmTimer){
        window.clearTimeout(carouselWarmTimer);
        carouselWarmTimer=0;
      }
    }

    function setCarouselUi(activeSlide){
      slideButtons.forEach(function(button){
        var active=button.dataset.vs22hTarget===activeSlide;
        button.classList.toggle("is-active",active);
        button.setAttribute("aria-current",active?"true":"false");
      });
      updateCarouselUi();
    }

    function updateCarouselUi(){
      if(!carouselAllowed)return;
      var remainingMs;
      var ratio;
      if(slidePrimaryActive){
        var elapsed=Math.max(0,performance.now()-primaryStartedAt);
        remainingMs=Math.max(0,primaryDuration-elapsed);
        ratio=Math.min(1,elapsed/primaryDuration);
      }else{
        var duration=Number.isFinite(video.duration)&&video.duration>0
          ?video.duration
          :fallbackVideoDuration;
        var current=Math.max(0,video.currentTime||0);
        remainingMs=Math.max(0,(duration-current)*1000);
        ratio=Math.min(1,current/duration);
      }
      if(countdown){
        countdown.textContent=String(Math.max(0,Math.ceil(remainingMs/1000))).padStart(2,"0");
      }
      if(progress){
        progress.style.transform="scaleX("+ratio.toFixed(4)+")";
      }
    }

    function startCarouselUi(){
      if(carouselUiTimer)return;
      updateCarouselUi();
      carouselUiTimer=window.setInterval(updateCarouselUi,200);
    }

    function stopCarouselUi(){
      if(!carouselUiTimer)return;
      window.clearInterval(carouselUiTimer);
      carouselUiTimer=0;
    }

    function prepareVideo(){
      if(!carouselAllowed||!video||video.src)return;
      var source=video.dataset.vs22hVideoSrc;
      if(!source)return;
      video.preload="auto";
      video.src=source;
      video.load();
      root.dataset.vs22hVideoPrepared="true";
    }

    function showPrimarySlide(){
      clearCarouselTimers();
      if(video){
        video.pause();
        try{video.currentTime=0;}catch(error){}
      }
      if(videoPlayButton)videoPlayButton.hidden=true;
      root.classList.remove("vs22h-show-video");
      if(primarySlide)primarySlide.setAttribute("aria-hidden","false");
      if(videoSlide)videoSlide.setAttribute("aria-hidden","true");
      slidePrimaryActive=true;
      setCarouselUi("primary");
      onPrimarySlideActivated();
      syncVisibility();
      armPrimarySlide();
    }

    function showVideoSlide(){
      if(
        !carouselAllowed
        ||!carouselInView
        ||document.hidden
        ||!slidePrimaryActive
      )return;
      clearCarouselTimers();
      prepareVideo();
      slidePrimaryActive=false;
      if(primarySlide)primarySlide.setAttribute("aria-hidden","true");
      if(videoSlide)videoSlide.setAttribute("aria-hidden","false");
      root.classList.add("vs22h-show-video");
      setCarouselUi("video");
      syncVisibility();
      try{video.currentTime=0;}catch(error){}
      var playResult=video.play();
      if(playResult&&typeof playResult.catch==="function"){
        playResult.catch(function(){
          if(videoPlayButton)videoPlayButton.hidden=false;
        });
      }
    }

    function armPrimarySlide(){
      clearCarouselTimers();
      if(
        !carouselAllowed
        ||!carouselInView
        ||document.hidden
        ||!slidePrimaryActive
      )return;
      carouselWarmTimer=window.setTimeout(prepareVideo,5000);
      carouselPrimaryTimer=window.setTimeout(showVideoSlide,primaryDuration);
      primaryStartedAt=performance.now();
      setCarouselUi("primary");
      startCarouselUi();
    }

    if(carouselAllowed){
      root.dataset.vs22hCarousel="enabled";
      slideButtons.forEach(function(button){
        button.addEventListener("click",function(){
          var target=button.dataset.vs22hTarget;
          if(target==="primary"&&!slidePrimaryActive){
            showPrimarySlide();
          }else if(target==="video"&&slidePrimaryActive){
            showVideoSlide();
          }
        });
      });
      video.addEventListener("ended",showPrimarySlide);
      video.addEventListener("error",function(){
        if(!slidePrimaryActive)showPrimarySlide();
      });
      video.addEventListener("playing",function(){
        if(videoPlayButton)videoPlayButton.hidden=true;
        startCarouselUi();
      });
      video.addEventListener("loadedmetadata",updateCarouselUi);
      if(videoPlayButton){
        videoPlayButton.addEventListener("click",function(){
          prepareVideo();
          var playResult=video.play();
          if(playResult&&typeof playResult.catch==="function"){
            playResult.catch(function(){});
          }
        });
      }
      if("IntersectionObserver" in window){
        new IntersectionObserver(function(entries){
          carouselInView=Boolean(entries[0]&&entries[0].isIntersecting);
          if(!carouselInView){
            clearCarouselTimers();
            stopCarouselUi();
            if(video&&!slidePrimaryActive)video.pause();
          }else if(slidePrimaryActive){
            armPrimarySlide();
          }else{
            startCarouselUi();
            var playResult=video.play();
            if(playResult&&typeof playResult.catch==="function"){
              playResult.catch(function(){});
            }
          }
        },{threshold:.08}).observe(stage);
      }
      document.addEventListener("visibilitychange",function(){
        if(document.hidden){
          clearCarouselTimers();
          stopCarouselUi();
          if(video&&!slidePrimaryActive)video.pause();
        }else if(carouselInView&&slidePrimaryActive){
          armPrimarySlide();
        }else if(carouselInView&&video){
          startCarouselUi();
          var playResult=video.play();
          if(playResult&&typeof playResult.catch==="function"){
            playResult.catch(function(){});
          }
        }
      });
      armPrimarySlide();
    }else{
      root.dataset.vs22hCarousel=saveData
        ?"save-data-static"
        :(reduceMotion.matches?"reduced-motion-static":"unsupported-video-static");
    }

    function syncHeaderSpacer(){
      headerResizeFrame=0;
      if(!headerSpacer||!desktopMedia.matches){
        root.style.setProperty("--vs22h-header-overlap","0px");
        return;
      }

      var rootTop=root.getBoundingClientRect().top;
      if(rootTop<-1)return;
      var selectors=[
        ".shopify-section-group-header-group",
        "#shopify-section-header",
        "sticky-header",
        ".header-wrapper",
        "header.header"
      ];
      var candidates=document.querySelectorAll(selectors.join(","));
      var overlap=0;

      for(var index=0;index<candidates.length;index+=1){
        var candidate=candidates[index];
        if(candidate.contains(root))continue;
        var styles=window.getComputedStyle(candidate);
        if(styles.display==="none"||styles.visibility==="hidden")continue;
        var rect=candidate.getBoundingClientRect();
        if(rect.width<1||rect.height<1||rect.top>rootTop+1)continue;
        overlap=Math.max(overlap,Math.ceil(rect.bottom-rootTop));
      }

      root.style.setProperty("--vs22h-header-overlap",Math.max(0,Math.min(overlap,320))+"px");
    }

    function requestHeaderSpacerSync(){
      if(headerResizeFrame)return;
      headerResizeFrame=window.requestAnimationFrame(syncHeaderSpacer);
    }

    requestHeaderSpacerSync();
    window.setTimeout(requestHeaderSpacerSync,250);
    window.setTimeout(requestHeaderSpacerSync,1000);
    window.addEventListener("resize",requestHeaderSpacerSync,{passive:true});
    if(desktopMedia.addEventListener)desktopMedia.addEventListener("change",requestHeaderSpacerSync);

    if("ResizeObserver" in window){
      headerResizeObserver=new ResizeObserver(requestHeaderSpacerSync);
      var headerCandidates=document.querySelectorAll([
        ".shopify-section-group-header-group",
        "#shopify-section-header",
        "sticky-header",
        ".header-wrapper",
        "header.header"
      ].join(","));
      for(var headerIndex=0;headerIndex<headerCandidates.length;headerIndex+=1){
        headerResizeObserver.observe(headerCandidates[headerIndex]);
      }
    }

    function syncPromoMask(){
      if(!promoImage)return;
      var selectedSource=promoImage.currentSrc||promoImage.src;
      if(selectedSource)root.style.setProperty("--vs22h-promo-mask",'url("'+selectedSource.replace(/"/g,"%22")+'")');
    }

    syncPromoMask();
    if(promoImage)promoImage.addEventListener("load",syncPromoMask);
    if(desktopMedia.addEventListener)desktopMedia.addEventListener("change",syncPromoMask);

    if(!reduceMotion.matches&&!saveData&&finePointer.matches&&desktopMedia.matches){
      var targetX=0;
      var targetY=0;
      var currentX=0;
      var currentY=0;
      var parallaxFrame=0;

      function renderParallax(){
        currentX+=(targetX-currentX)*.12;
        currentY+=(targetY-currentY)*.12;
        root.style.setProperty("--vs22h-bg-x",(-currentX*2).toFixed(2)+"px");
        root.style.setProperty("--vs22h-bg-y",(-currentY*2).toFixed(2)+"px");
        root.style.setProperty("--vs22h-promo-x",(currentX*5).toFixed(2)+"px");
        root.style.setProperty("--vs22h-promo-y",(currentY*5).toFixed(2)+"px");
        if(Math.abs(targetX-currentX)>.003||Math.abs(targetY-currentY)>.003){
          parallaxFrame=requestAnimationFrame(renderParallax);
        }else{
          parallaxFrame=0;
        }
      }

      function requestParallax(){
        if(!parallaxFrame)parallaxFrame=requestAnimationFrame(renderParallax);
      }

      stage.addEventListener("pointermove",function(event){
        var rect=stage.getBoundingClientRect();
        targetX=Math.max(-1,Math.min(1,((event.clientX-rect.left)/rect.width-.5)*2));
        targetY=Math.max(-1,Math.min(1,((event.clientY-rect.top)/rect.height-.5)*2));
        requestParallax();
      },{passive:true});

      stage.addEventListener("pointerleave",function(){
        targetX=0;
        targetY=0;
        requestParallax();
      },{passive:true});
    }

    if(!backCanvas||!frontCanvas||reduceMotion.matches)return;
    if(saveData){
      root.classList.remove("vs22h-motion");
      frontCanvas.dataset.vs22hProfile="save-data-static";
      return;
    }

    var backContext=backCanvas.getContext("2d");
    var frontContext=frontCanvas.getContext("2d");
    if(!backContext||!frontContext)return;

    var goldFront=["#D8A53B","#F0C96B","#FFE3A0"];
    var goldBack=["#B98118","#9C6712","#D8A53B"];
    var particles=[];
    var pixelRatio=1;
    var cssWidth=0;
    var cssHeight=0;
    var desktopEnhanced=false;
    var ambientTarget=0;
    var intersecting=true;
    var documentVisible=!document.hidden;
    var visible=true;
    var animationFrame=0;
    var lastTime=0;
    var canvasAge=0;
    var nextSparkleAt=8000;
    var openingPlan=null;
    var openingBatches=[false,false,false];
    var preludeEmitted=false;
    var heroRibbonEmitted={};
    var openingArcsEmitted=false;
    var mobileBurstEmitted=false;
    var openingScheduled=false;
    var openingScheduleToken=0;
    var secondWaveDue=false;
    var secondWaveStarted=false;
    var mobileEchoDue=false;
    var mobileEchoStarted=false;
    var secondaryScheduleToken=0;
    var nextAmbientRibbonAt=9000;
    var fpsWindowStart=0;
    var fpsFrames=0;
    var maxFrameGap=0;

    function randomBetween(min,max){
      return min+Math.random()*(max-min);
    }

    function choose(items){
      return items[Math.floor(Math.random()*items.length)];
    }

    function shuffle(items){
      for(var index=items.length-1;index>0;index-=1){
        var swapIndex=Math.floor(Math.random()*(index+1));
        var value=items[index];
        items[index]=items[swapIndex];
        items[swapIndex]=value;
      }
      return items;
    }

    function repeatValue(value,count){
      var result=[];
      for(var index=0;index<count;index+=1)result.push(value);
      return result;
    }

    function setMetric(name,value){
      frontCanvas.dataset[name]=String(value);
    }

    function resizeCanvases(){
      var previousWidth=cssWidth;
      var previousHeight=cssHeight;
      var previousDesktop=desktopEnhanced;
      var rect=stage.getBoundingClientRect();
      cssWidth=Math.max(1,Math.round(rect.width));
      cssHeight=Math.max(1,Math.round(rect.height));
      desktopEnhanced=desktopMedia.matches;
      pixelRatio=desktopEnhanced
        ?(lowPower?1:Math.min(window.devicePixelRatio||1,1.5))
        :(lowPower?1:Math.min(window.devicePixelRatio||1,1.25));

      if(previousWidth&&previousHeight){
        particles.forEach(function(particle){
          particle.x*=cssWidth/previousWidth;
          particle.y*=cssHeight/previousHeight;
        });
      }
      if(previousWidth&&previousDesktop!==desktopEnhanced){
        particles=[];
        openingPlan=null;
      }

      frontCanvas.width=Math.round(cssWidth*pixelRatio);
      frontCanvas.height=Math.round(cssHeight*pixelRatio);
      frontContext.setTransform(pixelRatio,0,0,pixelRatio,0,0);

      if(desktopEnhanced){
        backCanvas.width=Math.round(cssWidth*pixelRatio);
        backCanvas.height=Math.round(cssHeight*pixelRatio);
        backContext.setTransform(pixelRatio,0,0,pixelRatio,0,0);
        ambientTarget=lowPower?8:10;
        setMetric("vs22hProfile",lowPower?"desktop-low":"desktop-full");
      }else{
        backCanvas.width=1;
        backCanvas.height=1;
        ambientTarget=lowPower?5:6;
        setMetric("vs22hProfile",lowPower?"mobile-low-v1":"mobile-v1");
      }
      setMetric("vs22hAmbientTarget",ambientTarget);
      replenishAmbient(true);
    }

    function createAmbientParticle(depth,initial,field){
      var scale=Math.max(.55,Math.min(1.18,cssWidth/1440));
      var mobile=!desktopEnhanced;
      var type=mobile
        ?(Math.random()<.75?"foil":"strip")
        :(depth==="front"?"curl":(Math.random()<.7?"foil":"strip"));
      var x;
      var y;
      var edgeDirection=1;

      if(mobile){
        var mobileEdge=Math.random()<.72;
        x=mobileEdge
          ?cssWidth*(Math.random()<.5?randomBetween(.025,.16):randomBetween(.84,.975))
          :randomBetween(cssWidth*.2,cssWidth*.8);
        y=randomBetween(cssHeight*.025,cssHeight*.47);
      }else if(field==="left-product"){
        x=randomBetween(cssWidth*.04,cssWidth*.42);
        y=randomBetween(cssHeight*.045,cssHeight*.34);
      }else if(depth==="back"){
        x=Math.random()*cssWidth;
        y=Math.random()*cssHeight;
      }else if(depth==="front"){
        var onLeft=Math.random()<.5;
        x=cssWidth*(onLeft?randomBetween(.012,.045):randomBetween(.955,.988));
        y=cssHeight*(Math.random()<.55?randomBetween(.06,.25):randomBetween(.72,.93));
        edgeDirection=onLeft?1:-1;
      }else if(Math.random()<.72){
        var field=choose(["promo-top","promo-left","promo-right"]);
        if(field==="promo-top"){
          x=randomBetween(cssWidth*.53,cssWidth*.94);
          y=randomBetween(cssHeight*.04,cssHeight*.13);
        }else if(field==="promo-left"){
          x=randomBetween(cssWidth*.43,cssWidth*.49);
          y=randomBetween(cssHeight*.13,cssHeight*.61);
        }else{
          x=randomBetween(cssWidth*.945,cssWidth*.985);
          y=randomBetween(cssHeight*.13,cssHeight*.61);
        }
      }else{
        x=Math.random()*cssWidth;
        y=Math.random()*cssHeight;
      }

      var life=mobile
        ?randomBetween(6500,13000)
        :(depth==="back"?randomBetween(10000,17000):(depth==="front"?randomBetween(9800,15000):randomBetween(8500,14500)));
      var size=mobile
        ?randomBetween(1.8,4.6)*scale
        :(field==="left-product"?randomBetween(1.15,2.5)*scale:(depth==="back"?randomBetween(1.4,3.2)*scale:randomBetween(3,6.4)*scale));
      var length=type==="curl"
        ?randomBetween(34,58)*scale
        :(type==="strip"?randomBetween(10,18)*scale:size);
      return {
        ambient:true,
        field:field||"",
        mode:"ambient",
        type:type,
        depth:mobile?"mid":depth,
        layer:mobile||depth!=="back"?"front":"back",
        x:x,
        y:y,
        vx:mobile
          ?randomBetween(-.08,.08)*scale
          :(field==="left-product"?randomBetween(.018,.055)*scale:(depth==="back"?randomBetween(-.045,.055)*scale:(depth==="front"?edgeDirection*randomBetween(.025,.075)*scale:randomBetween(-.09,.11)*scale))),
        vy:mobile
          ?randomBetween(-.09,.06)*scale
          :(field==="left-product"?randomBetween(.005,.032)*scale:(depth==="back"?randomBetween(-.025,.045)*scale:(depth==="front"?randomBetween(-.035,.055)*scale:randomBetween(-.05,.09)*scale))),
        gravity:0,
        rotation:Math.random()*Math.PI*2,
        spin:mobile?randomBetween(-.012,.012):(depth==="back"?randomBetween(-.008,.008):randomBetween(-.018,.018)),
        width:type==="strip"?length:size,
        height:type==="strip"?randomBetween(2,3.4)*scale:size*randomBetween(.44,.8),
        length:length,
        thickness:type==="curl"?randomBetween(2.2,3.6)*scale:randomBetween(1.5,2.6)*scale,
        amplitude:type==="curl"?randomBetween(6,11)*scale:randomBetween(2.5,5)*scale,
        frontColor:choose(goldFront),
        backColor:choose(goldBack),
        color:choose(goldFront),
        age:initial?life*randomBetween(-.28,.72):0,
        life:life,
        phase:Math.random()*Math.PI*2,
        alphaMax:mobile
          ?randomBetween(.2,.4)
          :(field==="left-product"?randomBetween(.16,.28):(depth==="back"?randomBetween(.2,.38):(depth==="front"?randomBetween(.24,.42):randomBetween(.38,.62)))),
        blur:depth==="front"&&!lowPower?randomBetween(.65,1.15):0
      };
    }

    function createOpeningParticle(type,zone,depth,mode){
      var scale=Math.max(.58,Math.min(1.18,cssWidth/1440));
      var size=randomBetween(4,8)*scale;
      var x=0;
      var y=0;
      var vx=0;
      var vy=0;

      if(zone==="top"){
        x=randomBetween(cssWidth*.055,cssWidth*.97);
        y=-size*2;
        vx=randomBetween(-.32,.32)*scale;
        vy=randomBetween(.38,.8)*scale;
      }else if(zone==="right"){
        x=cssWidth+size*2;
        y=randomBetween(cssHeight*.025,cssHeight*.46);
        vx=randomBetween(-1.28,-.68)*scale;
        vy=randomBetween(.14,.56)*scale;
      }else if(zone==="promo"){
        var field=choose(["top","left","right"]);
        if(field==="top"){
          x=randomBetween(cssWidth*.54,cssWidth*.93);
          y=randomBetween(cssHeight*.045,cssHeight*.115);
          vx=randomBetween(-.26,.26)*scale;
          vy=randomBetween(.18,.5)*scale;
        }else if(field==="left"){
          x=randomBetween(cssWidth*.43,cssWidth*.485);
          y=randomBetween(cssHeight*.14,cssHeight*.6);
          vx=randomBetween(-.58,-.16)*scale;
          vy=randomBetween(.08,.46)*scale;
        }else{
          x=randomBetween(cssWidth*.945,cssWidth*.98);
          y=randomBetween(cssHeight*.13,cssHeight*.59);
          vx=randomBetween(-.66,-.22)*scale;
          vy=randomBetween(.08,.44)*scale;
        }
      }else{
        x=randomBetween(cssWidth*.03,cssWidth*.41);
        y=Math.random()<.48?-size:randomBetween(cssHeight*.04,cssHeight*.32);
        vx=mode==="left-product"?randomBetween(.06,.22)*scale:randomBetween(.08,.4)*scale;
        vy=mode==="left-product"?randomBetween(.12,.34)*scale:randomBetween(.28,.65)*scale;
      }

      var isCurl=type==="curl";
      var isStrip=type==="strip";
      var isSparkle=type==="sparkle";
      var life=isCurl?randomBetween(2200,2800):randomBetween(1800,2600);
      if(mode==="prelude")life=randomBetween(2300,2800);
      if(mode==="left-product")life=randomBetween(1200,1800);
      return {
        ambient:false,
        mode:isSparkle?"sparkle":mode,
        type:type,
        depth:depth,
        layer:depth==="back"?"back":"front",
        x:x,
        y:y,
        vx:isSparkle?0:vx,
        vy:isSparkle?0:vy,
        gravity:isSparkle?0:randomBetween(.004,.01)*scale,
        rotation:Math.random()*Math.PI*2,
        spin:randomBetween(-.034,.034),
        width:isStrip?randomBetween(14,24)*scale:size,
        height:isStrip?randomBetween(3.4,5.8)*scale:size*randomBetween(.5,.9),
        length:isCurl?randomBetween(36,64)*scale:size,
        thickness:isCurl?randomBetween(2.2,4)*scale:randomBetween(1.4,2.5)*scale,
        amplitude:isCurl?randomBetween(7,13)*scale:randomBetween(2.5,5)*scale,
        frontColor:choose(goldFront),
        backColor:choose(goldBack),
        color:choose(goldFront),
        age:0,
        life:isSparkle?randomBetween(650,900):life,
        phase:Math.random()*Math.PI*2,
        alphaMax:depth==="back"
          ?(mode==="left-product"?randomBetween(.28,.46):randomBetween(.24,.42))
          :(depth==="front"?randomBetween(.3,.5):randomBetween(.5,.72)),
        blur:depth==="front"&&!lowPower?randomBetween(.5,1):0
      };
    }

    function createMobileBurstParticle(index,total,echo){
      var scale=Math.max(.55,Math.min(1,cssWidth/390));
      var foilCount=echo?Math.ceil(total*.8):(lowPower?7:13);
      var stripCount=echo?total-foilCount:(lowPower?3:5);
      var type=index<foilCount?"foil":(index<foilCount+stripCount?"strip":"sparkle");
      var fromRight=index%4===0;
      var size=randomBetween(2.5,5.5)*scale;
      return {
        ambient:false,
        mode:type==="sparkle"?"sparkle":(echo?"mobile-echo":"mobile-burst"),
        type:type,
        depth:"mid",
        layer:"front",
        mobileTopOnly:true,
        x:fromRight?cssWidth+size:randomBetween(cssWidth*.08,cssWidth*.96),
        y:fromRight?randomBetween(cssHeight*.025,cssHeight*.43):-size,
        vx:type==="sparkle"?0:(fromRight?randomBetween(-.95,-.58)*scale:randomBetween(-.24,.28)*scale),
        vy:type==="sparkle"?0:(fromRight?randomBetween(.08,.28)*scale:randomBetween(.2,.48)*scale),
        gravity:type==="sparkle"?0:randomBetween(.002,.006)*scale,
        rotation:Math.random()*Math.PI*2,
        spin:randomBetween(-.04,.04),
        width:type==="strip"?randomBetween(8,14)*scale:size,
        height:type==="strip"?randomBetween(1.8,3)*scale:size*randomBetween(.4,.8),
        length:size,
        thickness:1.5,
        amplitude:2.5,
        frontColor:choose(goldFront),
        backColor:choose(goldBack),
        color:choose(goldFront),
        age:0,
        life:type==="sparkle"?randomBetween(540,760):(echo?randomBetween(620,820):randomBetween(900,1350)),
        phase:Math.random()*Math.PI*2,
        alphaMax:type==="sparkle"?randomBetween(.58,.76):randomBetween(.46,.68),
        blur:0
      };
    }

    function createFieldSparkle(delay,anchorIndex){
      var anchors=[
        [.68,.105],
        [.515,.355],
        [.895,.355],
        [.84,.545],
        [.59,.485]
      ];
      var anchor=anchors[anchorIndex%anchors.length];
      var scale=Math.max(.62,Math.min(1.14,cssWidth/1440));
      var size=randomBetween(4.5,7.5)*scale;
      return {
        ambient:false,
        mode:"sparkle",
        type:"sparkle",
        depth:"mid",
        layer:"front",
        x:cssWidth*(anchor[0]+randomBetween(-.012,.012)),
        y:cssHeight*(anchor[1]+randomBetween(-.016,.016)),
        vx:0,
        vy:0,
        gravity:0,
        rotation:Math.random()*Math.PI*.5,
        spin:randomBetween(-.01,.01),
        width:size,
        height:size,
        length:size,
        thickness:1,
        amplitude:0,
        frontColor:"#FFE3A0",
        backColor:"#D8A53B",
        color:choose(["#F0C96B","#FFE3A0"]),
        age:-delay,
        life:randomBetween(620,850),
        phase:Math.random()*Math.PI*2,
        alphaMax:randomBetween(.64,.86),
        blur:0
      };
    }

    function createEchoCurl(side){
      var scale=Math.max(.62,Math.min(1.16,cssWidth/1440));
      var fromLeft=side==="left";
      return {
        ambient:false,
        mode:"echo",
        type:"curl",
        depth:fromLeft?"mid":"front",
        layer:"front",
        x:cssWidth*(fromLeft ? .465 : .968),
        y:cssHeight*(fromLeft ? .18 : .285),
        vx:(fromLeft?-.38:-.56)*scale,
        vy:(fromLeft ? .15 : .08)*scale,
        gravity:0,
        rotation:fromLeft?-.55:2.65,
        spin:fromLeft ? .006 : -.005,
        width:0,
        height:0,
        length:randomBetween(64,82)*scale,
        thickness:randomBetween(3.4,4.8)*scale,
        amplitude:randomBetween(10,15)*scale,
        frontColor:"#F0C96B",
        backColor:"#B98118",
        color:choose(["#D8A53B","#F0C96B"]),
        age:0,
        life:randomBetween(1250,1450),
        phase:Math.random()*Math.PI*2,
        alphaMax:randomBetween(.66,.82),
        blur:fromLeft||lowPower?0:.45
      };
    }

    function createEchoFoil(index){
      var type=index%3===1?"strip":"foil";
      var particle=createOpeningParticle(type,"promo",index%3===0?"back":"mid","echo");
      var scale=Math.max(.62,Math.min(1.18,cssWidth/1440));
      particle.x=cssWidth*(.93+index*.009);
      particle.y=cssHeight*(.075+index*.058);
      particle.vx=randomBetween(.28,.58)*scale;
      particle.vy=randomBetween(.42,.72)*scale;
      particle.gravity=randomBetween(.006,.01)*scale;
      particle.rotation=randomBetween(.35,1.05);
      particle.spin=randomBetween(-.026,.026);
      particle.life=randomBetween(720,980);
      particle.alphaMax=particle.depth==="back"?randomBetween(.42,.56):randomBetween(.62,.78);
      particle.width*=type==="strip"?1.55:1.78;
      particle.height*=type==="strip"?1.5:1.7;
      particle.blur=0;
      return particle;
    }

    function cubicPoint(path,t){
      var inverse=1-t;
      var inverse2=inverse*inverse;
      var t2=t*t;
      return {
        x:inverse2*inverse*path[0][0]+3*inverse2*t*path[1][0]+3*inverse*t2*path[2][0]+t2*t*path[3][0],
        y:inverse2*inverse*path[0][1]+3*inverse2*t*path[1][1]+3*inverse*t2*path[2][1]+t2*t*path[3][1]
      };
    }

    function cubicTangent(path,t){
      var inverse=1-t;
      return {
        x:3*inverse*inverse*(path[1][0]-path[0][0])+6*inverse*t*(path[2][0]-path[1][0])+3*t*t*(path[3][0]-path[2][0]),
        y:3*inverse*inverse*(path[1][1]-path[0][1])+6*inverse*t*(path[2][1]-path[1][1])+3*t*t*(path[3][1]-path[2][1])
      };
    }

    function createHeroRibbon(variant,mode){
      var scale=Math.max(.66,Math.min(1.24,cssWidth/1440));
      var specs={
        leftTop:{
          path:[[-.055,.025],[.09,.015],[.265,.16],[.455,.205]],
          width:17.1,span:.184,life:780,depth:"back",alpha:.94,soft:.3,twists:1,offset:.18
        },
        rightTop:{
          path:[[1.035,-.02],[.955,.015],[.925,.14],[.975,.335]],
          width:19.2,span:.175,life:1020,depth:"back",alpha:.92,soft:.38,twists:1,offset:.78
        },
        rightBottom:{
          path:[[.455,.405],[.535,.78],[.79,.965],[1.045,.865]],
          width:20,span:.157,life:860,depth:"front",alpha:.88,soft:1.05,twists:1,offset:.48
        },
        echoRight:{
          path:[[.895,.035],[.965,.025],[.995,.16],[.955,.35]],
          width:19.2,span:.212,life:900,depth:"front",alpha:.92,soft:.6,twists:1,offset:.72
        },
        ambientLeft:{
          path:[[-.07,.09],[.065,.035],[.205,.12],[.38,.085]],
          width:12,span:.17,life:1050,depth:"back",alpha:.3,soft:.25,twists:1.35,offset:.4
        },
        ambientRight:{
          path:[[1.06,.11],[.985,.045],[.935,.16],[.99,.36]],
          width:12,span:.17,life:1080,depth:"back",alpha:.28,soft:.25,twists:1.35,offset:1.1
        }
      };
      var spec=specs[variant];
      return {
        ambient:false,
        mode:mode||"hero-ribbon",
        type:"heroRibbon",
        variant:variant,
        depth:spec.depth,
        layer:spec.depth==="back"?"back":"front",
        path:spec.path,
        segmentSpan:spec.span,
        ribbonWidth:spec.width*scale,
        age:0,
        life:spec.life,
        phase:Math.random()*Math.PI*2,
        alphaMax:spec.alpha,
        softness:lowPower?0:spec.soft,
        twistTurns:spec.twists,
        twistOffset:spec.offset
      };
    }

    function createArcParticle(index,mode){
      var scale=Math.max(.62,Math.min(1.2,cssWidth/1440));
      var paths=[
        [[.39,.12],[.49,.24],[.54,.58],[.72,.82]],
        [[.49,.07],[.62,.18],[.77,.34],[.93,.56]],
        [[.55,.04],[.68,.12],[.83,.28],[.98,.51]],
        [[.42,.24],[.51,.42],[.67,.65],[.86,.88]],
        [[.63,.08],[.76,.18],[.88,.37],[1.02,.63]],
        [[.72,.12],[.84,.26],[.93,.49],[1.03,.77]]
      ];
      var depth=index%4===0?"back":"mid";
      var size=randomBetween(30,48)*scale;
      return {
        ambient:false,
        mode:mode||"arc-opening",
        type:"arc",
        depth:depth,
        layer:depth==="back"?"back":"front",
        path:paths[index%paths.length],
        x:0,
        y:0,
        vx:0,
        vy:0,
        gravity:0,
        rotation:0,
        spin:randomBetween(-.012,.012),
        width:size,
        height:randomBetween(4.4,7.2)*scale,
        length:size,
        thickness:randomBetween(2,3.4)*scale,
        amplitude:randomBetween(4,8)*scale,
        frontColor:choose(goldFront),
        backColor:choose(goldBack),
        color:choose(goldFront),
        age:mode==="arc-echo"?140-index*22:-index*randomBetween(42,78),
        life:mode==="arc-echo"?randomBetween(720,920):randomBetween(950,1350),
        phase:Math.random()*Math.PI*2,
        alphaMax:depth==="back"?randomBetween(.28,.43):randomBetween(.52,.76),
        blur:0
      };
    }

    function updateArcParticle(particle){
      var progress=Math.max(0,Math.min(1,particle.age/particle.life));
      var eased=.5-Math.cos(progress*Math.PI)*.5;
      var point=cubicPoint(particle.path,eased);
      var tangent=cubicTangent(particle.path,eased);
      particle.x=point.x*cssWidth;
      particle.y=point.y*cssHeight;
      particle.rotation=Math.atan2(tangent.y*cssHeight,tangent.x*cssWidth)+Math.sin(particle.age*.004+particle.phase)*.16;
    }

    function emitHeroRibbon(variant,mode){
      if(!visible||!desktopEnhanced)return;
      if(mode==="opening"&&heroRibbonEmitted[variant])return;
      if(mode==="opening")heroRibbonEmitted[variant]=true;
      particles.push(createHeroRibbon(variant,mode));
      startAnimation();
    }

    function emitOpeningArcs(){
      if(!visible||!desktopEnhanced||openingArcsEmitted)return;
      openingArcsEmitted=true;
      var count=lowPower?4:6;
      for(var index=0;index<count;index+=1)particles.push(createArcParticle(index,"arc-opening"));
      setMetric("vs22hArcCount",count);
      startAnimation();
    }

    function replenishAmbient(initial){
      if(!ambientTarget)return;
      var targets;
      if(desktopEnhanced){
        var leftTarget=2;
        var leftCount=particles.reduce(function(total,particle){
          return total+(particle.ambient&&particle.field==="left-product"?1:0);
        },0);
        while(leftCount<leftTarget){
          particles.push(createAmbientParticle("back",Boolean(initial),"left-product"));
          leftCount+=1;
        }
        targets=lowPower?{back:4,mid:2}:{back:6,mid:2};
      }else{
        targets={mid:ambientTarget};
      }
      Object.keys(targets).forEach(function(depth){
        var count=particles.reduce(function(total,particle){
          return total+(particle.ambient&&particle.depth===depth&&particle.field!=="left-product"?1:0);
        },0);
        while(count<targets[depth]){
          particles.push(createAmbientParticle(depth,Boolean(initial)));
          count+=1;
        }
      });
    }

    function buildDesktopOpeningPlan(){
      var preludeCount=2;
      var leftTypes=lowPower
        ?repeatValue("foil",3).concat(repeatValue("strip",1))
        :repeatValue("foil",5).concat(repeatValue("strip",2));
      var types=lowPower
        ?repeatValue("foil",7).concat(repeatValue("strip",3),repeatValue("sparkle",2))
        :repeatValue("foil",9).concat(repeatValue("strip",4),repeatValue("sparkle",2));
      var zones=lowPower
        ?repeatValue("top",2).concat(repeatValue("right",3),repeatValue("promo",7))
        :repeatValue("top",3).concat(repeatValue("right",5),repeatValue("promo",7));
      shuffle(types);
      shuffle(zones);
      var main=types.map(function(type,index){
        var depth=type==="sparkle"?"mid":(Math.random()<.46?"back":"mid");
        return {type:type,zone:zones[index],depth:depth};
      });
      shuffle(leftTypes);
      leftTypes.forEach(function(type){
        main.push({type:type,zone:"left",depth:"back",mode:"left-product"});
      });
      shuffle(main);
      var prelude=[];
      for(var index=0;index<preludeCount;index+=1){
        prelude.push({type:"foil",zone:"top",depth:"back"});
      }
      return {prelude:prelude,main:main};
    }

    function emitPrelude(){
      if(!visible||!desktopEnhanced||preludeEmitted)return;
      if(!openingPlan)openingPlan=buildDesktopOpeningPlan();
      preludeEmitted=true;
      openingPlan.prelude.forEach(function(item){
        particles.push(createOpeningParticle(item.type,item.zone,item.depth,"prelude"));
      });
      setMetric("vs22hPreludeCount",openingPlan.prelude.length);
      startAnimation();
    }

    function emitDesktopBatch(batchIndex){
      if(!visible||!desktopEnhanced||openingBatches[batchIndex])return;
      if(!openingPlan)openingPlan=buildDesktopOpeningPlan();
      var edges=lowPower?[0,5,11,16]:[0,7,15,22];
      openingBatches[batchIndex]=true;
      var batch=openingPlan.main.slice(edges[batchIndex],edges[batchIndex+1]);
      batch.forEach(function(item){
        particles.push(createOpeningParticle(item.type,item.zone,item.depth,item.mode||"opening"));
      });
      setMetric("vs22hBatchCounts",openingBatches.map(function(emitted,index){
        return emitted?edges[index+1]-edges[index]:0;
      }).join(","));
      if(batchIndex===2){
        var total=(lowPower?18:24);
        setMetric("vs22hBurstCount",total);
        setMetric("vs22hBurstShapes",lowPower
          ?JSON.stringify({foil:12,strip:4,sparkle:2})
          :JSON.stringify({foil:16,strip:6,sparkle:2}));
        setMetric("vs22hBurstZones",lowPower
          ?JSON.stringify({top:4,right:3,promo:7,leftProduct:4})
          :JSON.stringify({top:5,right:5,promo:7,leftProduct:7}));
      }
      startAnimation();
    }

    function emitMobileBurst(){
      if(!visible||desktopEnhanced||mobileBurstEmitted)return;
      mobileBurstEmitted=true;
      var count=lowPower?11:20;
      for(var index=0;index<count;index+=1)particles.push(createMobileBurstParticle(index,count,false));
      setMetric("vs22hBurstCount",count);
      setMetric("vs22hBurstShapes",lowPower
        ?JSON.stringify({foil:7,strip:3,sparkle:1})
        :JSON.stringify({foil:13,strip:5,sparkle:2}));
      startAnimation();
    }

    function scheduleOpening(){
      if(openingScheduled)return;
      openingScheduled=true;
      var token=++openingScheduleToken;
      if(desktopEnhanced){
        window.setTimeout(function(){if(token===openingScheduleToken)emitHeroRibbon("leftTop","opening");},520);
        window.setTimeout(function(){if(token===openingScheduleToken)emitHeroRibbon("rightTop","opening");},900);
        window.setTimeout(function(){if(token===openingScheduleToken)emitPrelude();},750);
        window.setTimeout(function(){if(token===openingScheduleToken)emitDesktopBatch(0);},1100);
        window.setTimeout(function(){if(token===openingScheduleToken)emitOpeningArcs();},1100);
        window.setTimeout(function(){if(token===openingScheduleToken)emitDesktopBatch(1);},1280);
        window.setTimeout(function(){if(token===openingScheduleToken)emitHeroRibbon("rightBottom","opening");},1320);
        window.setTimeout(function(){if(token===openingScheduleToken)emitDesktopBatch(2);},1460);
      }else{
        window.setTimeout(function(){if(token===openingScheduleToken)emitMobileBurst();},1100);
      }
    }

    function startSecondWave(){
      if(secondWaveStarted||!secondWaveDue||!visible||!desktopEnhanced)return;
      secondWaveStarted=true;
      root.classList.add("vs22h-afterglow");
      setMetric("vs22hSecondWave","true");
      window.setTimeout(function(){
        if(!visible)return;
        particles.push(createHeroRibbon("echoRight","echo-ribbon"));
        startAnimation();
      },70);
      window.setTimeout(function(){
        root.classList.add("vs22h-price-pulse");
      },150);
      window.setTimeout(function(){
        if(!visible)return;
        var echoCount=lowPower?6:7;
        for(var index=0;index<echoCount;index+=1){
          var echoFoil=createEchoFoil(index);
          echoFoil.age=-index*10;
          particles.push(echoFoil);
        }
        setMetric("vs22hSecondWaveFoils",echoCount);
        startAnimation();
      },190);
      window.setTimeout(function(){
        root.classList.add("vs22h-cta-pulse");
      },270);
      window.setTimeout(function(){
        root.classList.remove("vs22h-afterglow","vs22h-price-pulse","vs22h-cta-pulse");
      },1000);
      nextSparkleAt=canvasAge+randomBetween(3600,5200);
      startAnimation();
    }

    function startMobileEcho(){
      if(mobileEchoStarted||!mobileEchoDue||!visible||desktopEnhanced)return;
      mobileEchoStarted=true;
      root.classList.add("vs22h-mobile-echo","vs22h-price-pulse","vs22h-cta-pulse");
      var echoCount=lowPower?4:5;
      for(var index=0;index<echoCount;index+=1){
        var mobileEcho=createMobileBurstParticle(index,echoCount,true);
        mobileEcho.x=cssWidth*randomBetween(.68,.96);
        mobileEcho.y=cssHeight*randomBetween(.08,.38);
        mobileEcho.vx=randomBetween(.18,.42);
        mobileEcho.vy=randomBetween(.08,.25);
        mobileEcho.age=-index*24;
        particles.push(mobileEcho);
      }
      setMetric("vs22hMobileEcho","true");
      setMetric("vs22hMobileEchoFoils",echoCount);
      window.setTimeout(function(){
        root.classList.remove("vs22h-mobile-echo","vs22h-price-pulse","vs22h-cta-pulse");
      },780);
      startAnimation();
    }

    function scheduleSecondaryEvents(){
      var token=++secondaryScheduleToken;
      secondWaveDue=false;
      mobileEchoDue=false;
      window.setTimeout(function(){
        if(token!==secondaryScheduleToken)return;
        secondWaveDue=true;
        startSecondWave();
      },4550);
      window.setTimeout(function(){
        if(token!==secondaryScheduleToken)return;
        mobileEchoDue=true;
        startMobileEcho();
      },4300);
    }

    function addFieldSparkles(){
      if(!desktopEnhanced)return;
      var count=Math.random()<.8?1:2;
      for(var index=0;index<count;index+=1){
        particles.push(createFieldSparkle(index*160,Math.floor(Math.random()*5)));
      }
      nextSparkleAt=canvasAge+randomBetween(3000,5000);
    }

    function maybeAddAmbientRibbon(){
      if(!desktopEnhanced||canvasAge<nextAmbientRibbonAt)return;
      var active=particles.some(function(particle){
        return particle.type==="heroRibbon"&&particle.mode==="ambient-ribbon";
      });
      if(active)return;
      particles.push(createHeroRibbon(Math.random()<.5?"ambientLeft":"ambientRight","ambient-ribbon"));
      nextAmbientRibbonAt=canvasAge+randomBetween(8000,12000);
    }

    function traceCurl(drawContext,particle){
      var length=particle.length;
      var amplitude=particle.amplitude*(.82+.18*Math.sin(particle.age*.006+particle.phase));
      drawContext.beginPath();
      drawContext.moveTo(-length*.5,0);
      drawContext.quadraticCurveTo(-length*.375,-amplitude,-length*.25,0);
      drawContext.quadraticCurveTo(-length*.125,amplitude,0,0);
      drawContext.quadraticCurveTo(length*.125,-amplitude,length*.25,0);
      drawContext.quadraticCurveTo(length*.375,amplitude*.82,length*.5,0);
    }

    function drawHeroRibbon(drawContext,particle,alpha){
      var progress=Math.max(0,Math.min(1,particle.age/particle.life));
      var span=particle.segmentSpan;
      var end=progress*(1+span);
      var start=end-span;
      if(end<=0||start>=1)return;
      var from=Math.max(0,start);
      var to=Math.min(1,end);
      var segments=32;
      var previous=null;

      drawContext.save();
      drawContext.shadowColor="rgba(73,40,8,.26)";
      drawContext.shadowBlur=particle.softness*2.2;

      for(var index=0;index<=segments;index+=1){
        var local=index/segments;
        var t=from+(to-from)*local;
        var point=cubicPoint(particle.path,t);
        var tangent=cubicTangent(particle.path,t);
        var tangentX=tangent.x*cssWidth;
        var tangentY=tangent.y*cssHeight;
        var tangentLength=Math.max(.001,Math.sqrt(tangentX*tangentX+tangentY*tangentY));
        var normalX=-tangentY/tangentLength;
        var normalY=tangentX/tangentLength;
        var twist=Math.cos(local*Math.PI*particle.twistTurns+particle.twistOffset);
        var halfWidth=particle.ribbonWidth*(.78+.22*Math.abs(twist))*.5;
        var sample={
          x:point.x*cssWidth,
          y:point.y*cssHeight,
          leftX:point.x*cssWidth+normalX*halfWidth,
          leftY:point.y*cssHeight+normalY*halfWidth,
          rightX:point.x*cssWidth-normalX*halfWidth,
          rightY:point.y*cssHeight-normalY*halfWidth,
          twist:twist,
          local:local
        };

        if(previous){
          var faceTwist=(previous.twist+sample.twist)*.5;
          var frontFace=faceTwist>=0;
          var centerX=(previous.x+sample.x)*.5;
          var centerY=(previous.y+sample.y)*.5;
          var edgeX=(previous.leftX+sample.leftX-previous.rightX-sample.rightX)*.25;
          var edgeY=(previous.leftY+sample.leftY-previous.rightY-sample.rightY)*.25;
          var metalGradient=drawContext.createLinearGradient(
            centerX-edgeX,
            centerY-edgeY,
            centerX+edgeX,
            centerY+edgeY
          );
          if(frontFace){
            metalGradient.addColorStop(0,"#FFF0C6");
            metalGradient.addColorStop(.055,"#F4DDA2");
            metalGradient.addColorStop(.34,"#D5AC58");
            metalGradient.addColorStop(.57,"#9D6B25");
            metalGradient.addColorStop(.72,"#C99B46");
            metalGradient.addColorStop(.965,"#E9CE8A");
            metalGradient.addColorStop(1,"#FFF4D3");
          }else{
            metalGradient.addColorStop(0,"#E2BD76");
            metalGradient.addColorStop(.07,"#B98235");
            metalGradient.addColorStop(.4,"#8A5A23");
            metalGradient.addColorStop(.62,"#70471C");
            metalGradient.addColorStop(.9,"#B4833B");
            metalGradient.addColorStop(1,"#E8C982");
          }
          var specularCenter=.16+progress*.68;
          var specular=Math.max(0,1-Math.abs((previous.local+sample.local)*.5-specularCenter)/.052);
          drawContext.globalAlpha=alpha*(.92+specular*.08);
          drawContext.fillStyle=metalGradient;
          drawContext.beginPath();
          drawContext.moveTo(previous.leftX,previous.leftY);
          drawContext.lineTo(sample.leftX,sample.leftY);
          drawContext.lineTo(sample.rightX,sample.rightY);
          drawContext.lineTo(previous.rightX,previous.rightY);
          drawContext.closePath();
          drawContext.fill();

          drawContext.globalAlpha=alpha*(.5+specular*.46);
          drawContext.strokeStyle=frontFace?"#FFF7D8":"#EBCB91";
          drawContext.lineWidth=Math.max(.62,particle.ribbonWidth*.034);
          drawContext.beginPath();
          drawContext.moveTo(previous.leftX,previous.leftY);
          drawContext.lineTo(sample.leftX,sample.leftY);
          drawContext.stroke();

          drawContext.globalAlpha=alpha*.31;
          drawContext.strokeStyle=frontFace?"#9A6D2C":"#6D461B";
          drawContext.lineWidth=Math.max(.58,particle.ribbonWidth*.036);
          drawContext.beginPath();
          drawContext.moveTo(previous.rightX,previous.rightY);
          drawContext.lineTo(sample.rightX,sample.rightY);
          drawContext.stroke();

          drawContext.globalAlpha=alpha*.13;
          drawContext.strokeStyle="#765020";
          drawContext.lineWidth=Math.max(.5,particle.ribbonWidth*.028);
          drawContext.beginPath();
          drawContext.moveTo(previous.x,previous.y);
          drawContext.lineTo(sample.x,sample.y);
          drawContext.stroke();
        }
        previous=sample;
      }
      drawContext.restore();
    }

    function drawStrip(drawContext,particle,alpha){
      var wave=Math.sin(particle.age*.006+particle.phase)*particle.amplitude;
      drawContext.lineCap="round";
      drawContext.lineWidth=particle.height;
      drawContext.strokeStyle=particle.color;
      drawContext.beginPath();
      drawContext.moveTo(-particle.width*.5,0);
      drawContext.quadraticCurveTo(0,wave,particle.width*.5,0);
      drawContext.stroke();
      drawContext.globalAlpha=alpha*.3;
      drawContext.lineWidth=Math.max(.5,particle.height*.24);
      drawContext.strokeStyle="#FFE3A0";
      drawContext.beginPath();
      drawContext.moveTo(-particle.width*.5,-particle.height*.18);
      drawContext.quadraticCurveTo(0,wave-particle.height*.18,particle.width*.5,-particle.height*.18);
      drawContext.stroke();
    }

    function drawParticle(drawContext,particle,alpha){
      drawContext.save();
      drawContext.translate(particle.x,particle.y);
      drawContext.rotate(particle.rotation);
      if(particle.blur)drawContext.filter="blur("+particle.blur.toFixed(2)+"px)";

      if(particle.type==="foil"){
        var flipCos=Math.cos(particle.age*.009+particle.phase);
        var visualWidth=Math.max(.12,Math.abs(flipCos));
        drawContext.globalAlpha=alpha*(.46+.54*visualWidth);
        drawContext.scale(visualWidth,1);
        drawContext.fillStyle=flipCos>=0?particle.frontColor:particle.backColor;
        drawContext.beginPath();
        drawContext.moveTo(-particle.width*.5,-particle.height*.36);
        drawContext.lineTo(particle.width*.42,-particle.height*.5);
        drawContext.lineTo(particle.width*.5,particle.height*.34);
        drawContext.lineTo(-particle.width*.34,particle.height*.5);
        drawContext.closePath();
        drawContext.fill();
      }else if(particle.type==="strip"||particle.type==="arc"){
        drawContext.globalAlpha=alpha;
        drawStrip(drawContext,particle,alpha);
      }else if(particle.type==="curl"){
        drawContext.globalAlpha=alpha;
        drawContext.lineCap="round";
        drawContext.lineJoin="round";
        var gradient=drawContext.createLinearGradient(-particle.length*.5,0,particle.length*.5,0);
        gradient.addColorStop(0,"#9C6712");
        gradient.addColorStop(.35,"#F0C96B");
        gradient.addColorStop(.65,"#FFE3A0");
        gradient.addColorStop(1,"#B98118");
        drawContext.strokeStyle=gradient;
        drawContext.lineWidth=particle.thickness;
        traceCurl(drawContext,particle);
        drawContext.stroke();
        drawContext.globalAlpha=alpha*.3;
        drawContext.strokeStyle="#FFF1BE";
        drawContext.lineWidth=Math.max(.45,particle.thickness*.25);
        drawContext.translate(0,-particle.thickness*.22);
        traceCurl(drawContext,particle);
        drawContext.stroke();
      }else{
        var radius=particle.width;
        var pulse=.72+.28*Math.sin(particle.age*.012+particle.phase);
        drawContext.globalAlpha=alpha;
        drawContext.scale(pulse,pulse);
        drawContext.fillStyle=particle.color;
        drawContext.beginPath();
        drawContext.moveTo(0,-radius*1.45);
        drawContext.lineTo(radius*.24,-radius*.24);
        drawContext.lineTo(radius*1.45,0);
        drawContext.lineTo(radius*.24,radius*.24);
        drawContext.lineTo(0,radius*1.45);
        drawContext.lineTo(-radius*.24,radius*.24);
        drawContext.lineTo(-radius*1.45,0);
        drawContext.lineTo(-radius*.24,-radius*.24);
        drawContext.closePath();
        drawContext.fill();
      }
      drawContext.restore();
    }

    function particleAlpha(particle){
      if(particle.age<0)return 0;
      var progress=particle.age/particle.life;
      if(particle.type==="heroRibbon"){
        var ribbonIn=Math.min(1,Math.max(0,progress)/.11);
        var ribbonOut=Math.min(1,Math.max(0,1-progress)/.2);
        return Math.max(0,Math.min(ribbonIn,ribbonOut))*particle.alphaMax;
      }
      if(particle.mode==="sparkle"){
        return Math.max(0,Math.sin(Math.min(1,progress)*Math.PI))*particle.alphaMax;
      }
      if(particle.ambient){
        var fadeIn=Math.min(1,particle.age/1100);
        var fadeOut=Math.min(1,(particle.life-particle.age)/1600);
        var shimmer=.78+.22*Math.sin(particle.age*.0024+particle.phase);
        var presenceWave=.5+.5*Math.sin(particle.age*.00055+particle.phase);
        var presence=.05+.95*Math.pow(presenceWave,1.2);
        return Math.max(0,fadeIn*fadeOut*shimmer*presence*particle.alphaMax);
      }
      var intro=Math.min(1,particle.age/240);
      var outro=Math.min(1,(particle.life-particle.age)/(particle.life*.4));
      return Math.max(0,Math.min(intro,outro)*particle.alphaMax);
    }

    function animate(time){
      animationFrame=0;
      if(!visible)return;
      if(!lastTime){
        lastTime=time;
        fpsWindowStart=time;
      }
      var frameGap=time-lastTime;
      var delta=Math.min(2,frameGap/16.67);
      lastTime=time;
      maxFrameGap=Math.max(maxFrameGap,frameGap);
      fpsFrames+=1;
      canvasAge+=delta*16.67;
      frontContext.clearRect(0,0,cssWidth,cssHeight);
      if(desktopEnhanced)backContext.clearRect(0,0,cssWidth,cssHeight);

      var visibleCount=0;
      var backCount=0;
      var midCount=0;
      var frontCount=0;
      particles=particles.filter(function(particle){
        particle.age+=delta*16.67;
        if(particle.age<0)return true;
        if(particle.type==="heroRibbon"){
          var ribbonAlpha=particleAlpha(particle);
          if(ribbonAlpha>.055)visibleCount+=1;
          if(particle.depth==="back")backCount+=1;
          else frontCount+=1;
          if(ribbonAlpha>.008)drawHeroRibbon(particle.layer==="back"?backContext:frontContext,particle,ribbonAlpha);
          return particle.age<particle.life;
        }
        if(particle.type==="arc"){
          updateArcParticle(particle);
          var arcAlpha=particleAlpha(particle);
          if(arcAlpha>.055)visibleCount+=1;
          if(particle.depth==="back")backCount+=1;
          else midCount+=1;
          if(arcAlpha>.008)drawParticle(particle.layer==="back"?backContext:frontContext,particle,arcAlpha);
          return particle.age<particle.life;
        }
        particle.vy+=particle.gravity*delta;
        particle.x+=particle.vx*delta;
        particle.y+=particle.vy*delta;
        particle.rotation+=particle.spin*delta;
        if(particle.ambient){
          particle.x+=Math.sin(particle.age*.0011+particle.phase)*.05*delta;
          particle.y+=Math.cos(particle.age*.0008+particle.phase)*.024*delta;
        }
        var alpha=particleAlpha(particle);
        if(alpha>.055)visibleCount+=1;
        if(particle.depth==="back")backCount+=1;
        else if(particle.depth==="front")frontCount+=1;
        else midCount+=1;
        if(alpha>.008)drawParticle(particle.layer==="back"?backContext:frontContext,particle,alpha);
        return particle.age<particle.life
          &&particle.x>-90
          &&particle.x<cssWidth+90
          &&particle.y>-90
          &&particle.y<cssHeight+90
          &&(!particle.mobileTopOnly||particle.y<cssHeight*.52);
      });

      replenishAmbient(false);
      maybeAddAmbientRibbon();
      if(secondWaveStarted&&desktopEnhanced&&canvasAge>=nextSparkleAt)addFieldSparkles();
      setMetric("vs22hParticleCount",particles.length);
      setMetric("vs22hVisibleEstimate",visibleCount);
      setMetric("vs22hDepthCounts",backCount+","+midCount+","+frontCount);

      if(time-fpsWindowStart>=1000){
        var elapsed=time-fpsWindowStart;
        setMetric("vs22hFps",Math.round(fpsFrames*1000/elapsed));
        setMetric("vs22hMaxFrameGap",maxFrameGap.toFixed(1));
        fpsWindowStart=time;
        fpsFrames=0;
        maxFrameGap=0;
      }
      animationFrame=requestAnimationFrame(animate);
    }

    function startAnimation(){
      if(!animationFrame&&visible){
        lastTime=0;
        animationFrame=requestAnimationFrame(animate);
      }
    }

    function syncVisibility(){
      visible=intersecting&&documentVisible&&slidePrimaryActive;
      if(visible){
        scheduleOpening();
        if(secondWaveDue&&!secondWaveStarted)startSecondWave();
        if(mobileEchoDue&&!mobileEchoStarted)startMobileEcho();
        startAnimation();
      }else{
        openingScheduled=false;
        openingScheduleToken+=1;
        if(animationFrame){
          cancelAnimationFrame(animationFrame);
          animationFrame=0;
        }
      }
    }

    function restartPrimaryExperience(){
      openingScheduleToken+=1;
      openingScheduled=false;
      particles=[];
      openingPlan=null;
      openingBatches=[false,false,false];
      preludeEmitted=false;
      heroRibbonEmitted={};
      openingArcsEmitted=false;
      mobileBurstEmitted=false;
      secondWaveDue=false;
      secondWaveStarted=false;
      mobileEchoDue=false;
      mobileEchoStarted=false;
      canvasAge=0;
      nextSparkleAt=8000;
      nextAmbientRibbonAt=9000;
      fpsWindowStart=0;
      fpsFrames=0;
      maxFrameGap=0;
      root.classList.remove(
        "vs22h-afterglow",
        "vs22h-price-pulse",
        "vs22h-cta-pulse",
        "vs22h-mobile-echo",
        "vs22h-motion"
      );
      void root.offsetWidth;
      root.classList.add("vs22h-motion");
      resizeCanvases();
      replenishAmbient(true);
      scheduleSecondaryEvents();
    }

    onPrimarySlideActivated=restartPrimaryExperience;

    resizeCanvases();
    replenishAmbient(true);

    if("ResizeObserver" in window){
      new ResizeObserver(resizeCanvases).observe(stage);
    }else{
      window.addEventListener("resize",resizeCanvases,{passive:true});
    }

    if("IntersectionObserver" in window){
      new IntersectionObserver(function(entries){
        intersecting=Boolean(entries[0]&&entries[0].isIntersecting);
        syncVisibility();
      },{threshold:.08}).observe(stage);
    }else{
      syncVisibility();
    }

    scheduleSecondaryEvents();

      document.addEventListener("visibilitychange",function(){
        documentVisible=!document.hidden;
        syncVisibility();
      });
    }

    var script=document.currentScript;
    initializeVs22h(script&&script.closest(".vs22h-root"));

    if(document.documentElement.dataset.vs22hSectionListener!=="true"){
      document.documentElement.dataset.vs22hSectionListener="true";
      document.addEventListener("shopify:section:load",function(event){
        var target=event.target;
        if(!target)return;
        var root=target.matches&&target.matches(".vs22h-root")
          ?target
          :target.querySelector&&target.querySelector(".vs22h-root");
        initializeVs22h(root);
      });
    }
  })();
